import { createStyles, Grid, InputAdornment, TextField, Theme, withStyles, WithStyles } from '@material-ui/core'
import React from 'react'

interface WageDetailsProps extends WithStyles<typeof styles> {
	required?: boolean
	jobPlacementWage?: number
	jobPlacementWageFrequency: string
	handleWageChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	handleWageFrequencyChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

const WageDetails: React.FC<WageDetailsProps> = (props: WageDetailsProps) => {
	const {
		classes,
		handleWageChange,
		handleWageFrequencyChange,
		jobPlacementWage,
		jobPlacementWageFrequency,
		required,
	} = props

	return (
		<div className={classes.root}>
			<Grid container={true} spacing={8}>
				<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
					Wage&#58; { props.required === true && (<span className={classes.requiredField} >*</span> ) }
				</Grid>
				<Grid item={true} xs={12} sm={5}>
					<TextField
						name="jobPlacementWage"
						required={required}
						className={classes.dropdown}
						value={jobPlacementWage || ''}
						onChange={handleWageChange}
						margin="dense"
						variant="outlined"
						InputProps={{
							startAdornment: <InputAdornment position="start">$</InputAdornment>,
							inputProps: {
								type: 'number',
								min: '0.1',
								step: '0.01',
							},
						}}
					/>
				</Grid>
				<Grid item={true} xs={12} sm={4}>
					<TextField
						name="jobPlacementWageFrequency"
						select={true}
						className={classes.dropdown}
						required={required}
						value={jobPlacementWageFrequency}
						onChange={handleWageFrequencyChange}
						SelectProps={{
							native: true,
							MenuProps: {
								className: classes.select,
							}
						}}
						InputProps={{
							inputProps: {
								className: classes.select,
								required,
							},
						}}
						margin="dense"
						variant="outlined"
						label="Frequency"
					>
						{!jobPlacementWageFrequency && <option value="" />}
						{['HOUR', 'WEEK', 'YEAR'].map((option: string) => (
							<option key={option} value={option} data-auto={option}>
								{`/${option.toLowerCase()}`}
							</option>
						))}
					</TextField>
				</Grid>
			</Grid>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {},
		dropdown: { display: 'flex', flex: 1 },
		dropdownLabel: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-end',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		select: {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
		},
    requiredField:{
      color:'red'
    }
	})

export default withStyles(styles)(WageDetails)
